import "./App.css";
import { Routes, Route, Link } from "react-router-dom";
import DetailLayout from "./components/DetailLayout";
import HomeLayout from "./components/HomeLayout";

function App() {
  return (
    <div className="">
      <Routes>
        <Route path="/" element={<HomeLayout />} />
        <Route path="/:productName" element={<DetailLayout />} />
      </Routes>
    </div>
  );
}

export default App;
